import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './Pricingfaq.css';

// =========================================================
// Edit the answers here.
// A question with an EMPTY answer ('') is hidden automatically,
// so fill in the ones marked TODO before they appear on the site.
// =========================================================
const FAQS = [
  {
    q: 'Is the first class really free?',
    a: 'Yes. The trial class is free and there is no obligation. Your child meets an instructor live, 1-to-1, and builds something small. After it, we recommend the right course and package.',
  },
  {
    q: 'Which package should I choose?',
    a: 'All packages include the same live 1-to-1 classes, instructors and certificate. The only difference is the number of sessions: bigger packages cost less per session. If you are not sure, start with the free trial and we will recommend one.',
  },
  {
    q: 'How long is a session, and how many per week?',
    a: 'Each session is about 50 minutes, live on Zoom. Most students take 2 sessions per week, at days and times that fit around school.',
  },
  {
    q: 'What does my child need?',
    a: 'A laptop or computer is preferred, with a stable internet connection. For robotics, the kit is delivered to your home.',
  },
  {
    q: 'Can we change the teacher?',
    a: 'Yes. If you feel another instructor would be a better fit, you can request a change at any time.',
  },
  // ---------- TODO: add your real answers below ----------
  {
    q: 'How can I pay?',
    a: '', // TODO e.g. 'Cash, Whish, OMT, card or bank transfer.'
  },
  {
    q: 'What happens if my child misses a session?',
    a: '', // TODO your rescheduling rule
  },
  {
    q: 'How long do I have to use a package?',
    a: '', // TODO e.g. validity period, if any
  },
  {
    q: 'Can I get a refund?',
    a: '', // TODO your refund policy
  },
  {
    q: 'Is there a discount for siblings?',
    a: '', // TODO yes/no and how much
  },
];

const PricingFAQ = () => {
  const visible = FAQS.filter((f) => f.a && f.a.trim());
  if (!visible.length) return null;

  const whatsappUrl = `https://api.whatsapp.com/send/?phone=${process.env.REACT_APP_MOBILE_NUMBER1}&text=${encodeURIComponent(
    'Hi! I have a question about RoboMind packages.'
  )}&type=phone_number&app_absent=0`;

  return (
    <section className="rmfaq" aria-labelledby="rmfaq-title">
      <div className="rmfaq-inner">
        <h2 id="rmfaq-title" className="rmfaq-title">
          Questions parents ask
        </h2>

        <div className="rmfaq-list">
          {visible.map((item) => (
            <details key={item.q} className="rmfaq-item">
              <summary className="rmfaq-q">
                <span>{item.q}</span>
                <FontAwesomeIcon icon={faPlus} className="rmfaq-icon" aria-hidden="true" />
              </summary>
              <p className="rmfaq-a">{item.a}</p>
            </details>
          ))}
        </div>

        <p className="rmfaq-more">
          Another question?{' '}
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faWhatsapp} /> Ask us on WhatsApp
          </a>
        </p>
      </div>
    </section>
  );
};

export default PricingFAQ;